namespace GeniuzPOS.Administration {
    export enum PsParaGenTypeItemOnRecptMethod {
        ItemOnRecptMethod1 = 1,
        ItemOnRecptMethod2 = 2,
        ItemOnRecptMethod3 = 3,
        ItemOnRecptMethod4 = 4
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypeItemOnRecptMethod, 'GeniuzPOS.Administration.PsParaGenTypeItemOnRecptMethod', 'Administration.PsParaGenTypeItemOnRecptMethod');
}
